/**
 * Personal Message Line Item Property Injector
 * 
 * This script ensures the personal message input value (from a Custom Liquid block)
 * is included in the add-to-cart AJAX payload as a line item property.
 * 
 * The Venue theme renders Custom Liquid blocks outside the actual product form,
 * so we intercept the form submission and inject the personal message value.
 */
(function() {
  'use strict';

  /**
   * Get the personal message input value from the page
   * @returns {string} The personal message value, or empty string if not found/empty
   */
  function getPersonalMessageValue() {
    // Look for the personal message input by name attribute
    var input = document.querySelector('input[name="properties[Personal Message]"]');
    if (input && input.value && input.value.trim() !== '') {
      return input.value.trim();
    }
    return '';
  }

  /**
   * Inject personal message into form before submission
   * @param {HTMLFormElement} form - The product form element
   */
  function injectPersonalMessageIntoForm(form) {
    var personalMessage = getPersonalMessageValue();
    
    // Remove any existing hidden personal message input we may have added
    var existingHidden = form.querySelector('input[name="properties[Personal Message]"][type="hidden"]');
    if (existingHidden) {
      existingHidden.remove();
    }
    
    // Only inject if there's a message
    if (personalMessage) {
      var hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = 'properties[Personal Message]';
      hiddenInput.value = personalMessage;
      form.appendChild(hiddenInput);
    }
  }

  /**
   * Handle click events on add-to-cart buttons
   * Inject the personal message before the form submission is processed
   */
  function handleAddToCartClick(e) {
    var button = e.target.closest('button[name="add"], button[type="submit"]');
    if (!button) return;
    
    var form = button.closest('form');
    if (!form) return;
    
    // Check if this is a product form
    if (!form.querySelector('input[name="id"]')) return;
    
    // Inject the personal message into the form
    injectPersonalMessageIntoForm(form);
  }

  /**
   * Handle form submit events directly
   * This catches keyboard submissions and other submit methods
   */
  function handleFormSubmit(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    
    // Check if this is a product form
    if (!form.querySelector('input[name="id"]')) return;
    
    // Inject the personal message into the form
    injectPersonalMessageIntoForm(form);
  }

  // Use capturing phase to run before the theme's handlers
  document.addEventListener('click', handleAddToCartClick, true);
  document.addEventListener('submit', handleFormSubmit, true);

  // Also handle pointer events for touch devices
  document.addEventListener('pointerdown', function(e) {
    var button = e.target.closest('button[name="add"], button[type="submit"]');
    if (!button) return;
    
    var form = button.closest('form');
    if (!form || !form.querySelector('input[name="id"]')) return;
    
    // Pre-inject for touch devices to ensure it's ready
    injectPersonalMessageIntoForm(form);
  }, true);

})();